// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__a0fH9","inputWrap":"CustomTip_inputWrap__2BBpA"};